import ImageCustom from 'components/ImageCustom';
import * as React from 'react';
export default {
  ImageCustom,
  React
};